import React from 'react';
import { __ } from '@wordpress/i18n';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import getDateFromISOstring from '../../../../helpers/getDateFromISOstring';

const NotificationItemChosen = ({ item, closeFn, markReadFn, goFn }) => {
    const vai = (url) => { (goFn || closeFn)(item); navigate(url); };
    const navigate = useNavigate();
    // Il backend espone il tipo di notifica come redirectUrl: da li' ricaviamo dove portare.
    const tipo = item.notificationType || item.redirectUrl;

    return (
        <div className="notificationsSidebar__listItemChosen">
            <Button
                style={{marginBottom: '20px'}}
                type="button"
                outlined
                onClick={closeFn}
                label={__('Indietro', 'htr')}
                icon="pi pi-arrow-left" iconPos="left"/>
            <strong>{item.title}</strong>
            <span>{getDateFromISOstring(item.createdDate)}</span>
            {item.message}

            {['AMENDMENT_CREATION', 'AMENDMENT_EXPIRED', 'AMENDMENT_EXPIRATION_REMINDER'].includes(tipo)
                ? <Button
                    style={{ marginTop: '20px' }}
                    type="button"
                    onClick={() => vai('/richieste-integrazioni')}
                    label={__('Vai alle richieste di integrazioni', 'htr')}
                    icon="pi pi-arrow-right" iconPos="right"/> : null}

            {tipo === 'COMMUNICATION_RECEIVED'
                ? <Button
                    style={{ marginTop: '20px' }}
                    type="button"
                    onClick={() => vai('/comunicazioni')}
                    label={__('Vai alle comunicazioni', 'htr')}
                    icon="pi pi-inbox" iconPos="right"/> : null}

            {item.status === 'UNREAD'
                ? <Button
                style={{marginTop: '20px'}}
                type="button"
                outlined
                onClick={() => markReadFn(item.id)}
                label={__('Letto', 'htr')}/> : null}
        </div>
    )
}

export default NotificationItemChosen;
